// extracted by mini-css-extract-plugin
export var modal = "_gl-0";